import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getSourceSystemContent,
  selectAppraisal
} from "../store/selectors/AppraisalSlice";
import { useRetryRequest } from "./useRetryRequest";

export default function useGetFileStackKeys() {
  const dispatch = useDispatch();
  const {
    fileStack,
    data: { appraisalSessionId }
  } = useSelector(selectAppraisal);

  const { fileStackRequest } = useRetryRequest();

  const { photosRequired } = useSelector(getSourceSystemContent);

  const expires = fileStack.expires;
  const now = new Date().toISOString();

  const expired = now > expires;

  useEffect(() => {
    if ((!expires || expired) && photosRequired) {
      if (appraisalSessionId) {
        fileStackRequest();
      }
    }
    // eslint-disable-next-line
  }, [appraisalSessionId, dispatch, expired, expires, photosRequired]);
}
